export default "__VITE_ASSET__B01A9KMg__"